import * as actionTypes from './actionTypes';

export const resetViewCipGeneration = () => ({
  type: actionTypes.RESET_VIEW_CIP_GENERATION
});

export const resetViewCipReport = () => ({
  type: actionTypes.RESET_VIEW_CIP_REPORT
});

export const resetState = () => ({
  type: actionTypes.RESET_APP_STATE
});
